module.exports = __webpack_public_path__ + "img/62.1e92179a.jpeg";